import { render, staticRenderFns } from "./m-order-attribution-settings-dialog.vue?vue&type=template&id=451b6fd2&scoped=true&"
import script from "./m-order-attribution-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./m-order-attribution-settings-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b6fd2",
  null
  
)

export default component.exports